export const DEFAULT_UPLOAD_OPTION = 'From Disk';

export const UPLOAD_OPTION = ['From Disk', 'From Webcam'];
